/* eslint-disable import/no-named-as-default */
import { combineReducers } from '@reduxjs/toolkit';
import AuthSlice from './slices/AuthSlice';
import LayoutSlice from './slices/LayoutSlice';
import UserPreferencesSlice from './slices/UserPreferencesSlice';
import UserSlice from './slices/UserSlice';
import CalendarEvents from './slices/components/calendarEvents/CalendarEventsSlice';
import MessengerSlice from './slices/components/chat/MessengerSlice';
import ToastSlice from './slices/components/toast/ToastSlice';
import AgentSupervisionSlice from './slices/components/agentSupervision/AgentSupervisionSlice';
import QuickDisplaySlice from './slices/components/quickDisplay/QuickDisplaySlice';
import NetworksSlice from './slices/components/networks/NetworksSlice';
import OpenNaventSlice from './slices/components/openNavent/OpenNaventSlice';
import PropertyConfiguratorSlice from './slices/components/propertyConfigurator/PropertyConfiguratorSlice';
import SenderSlice from './slices/components/sender/SenderSlice';
import NotificationSlice from './slices/NotificationSlice';
import InstagramPostSlice from './slices/components/instagramPost/InstagramPostSlice';
import FavoritesSlice from './slices/components/favorites/FavoritesSlice';
import TemplateConfigSlice from './slices/components/webmanager/TemplateConfigSlice';
import PortalSlice from './slices/components/portals/PortalSlice';
import InstagramPublicationsSlice from './slices/components/instagramPublications/instagramPublicationsSlice';
import WebcontactSlice from './slices/components/webcontacts/WebcontactSlice';
import PropertiesVisitSlice from './slices/components/propertiesVisit/PropertiesVisitSlice';
import RightbarSlice from './slices/components/rightbar/RightbarSlice';
import HoggaxSlice from './slices/components/hoggax/HoggaxSlice';
import SharePropertiesMultipleSourcesSlice from './slices/components/SharePropertiesMultipleSources/SharePropertiesMultipleSourcesSlice';
import WhatsAppSlice from './slices/components/whatsapp/WhatsAppSlice';
import WhatsAppTemplatesSlice from './slices/components/whatsappTemplates/WhatsAppTemplatesSlice';
import DashboardSlice from './slices/components/dashboard/DashboardSlice';
import LeadsSlice from './slices/components/leads/LeadsSlice';
import FilterBarSlice from './slices/components/filterBar/FilterBarSlice';
import DevelopmentsSlice from './slices/components/developments/DevelopmentsSlice';
import CompanySettingsSlice from './slices/components/companySettings/CompanySettingsSlice';
import PdfConfigurationSlice from './slices/components/pdfConfiguration/PdfConfigurationSlice';
import ListingRegistrationSlice from './slices/components/listingRegistration/ListingRegistrationSlice';
import TasksSlice from './slices/components/tasks/TasksSlice';
import PortfolioManagerSlice from './slices/components/portfolioManager/PortfolioManagerSlice';
import EventTypesSlice from './slices/components/eventTypes/EventTypesSlice';
import ImporterSlice from './slices/components/importer/ImporterSlice';
import ReferenceCodesSlice from './slices/components/referenceCodes/ReferenceCodesSlice';
import BranchesAndTeamsSlice from './slices/components/branchesAndTeams/BranchesAndTeamsSlice';
import FileManagerSlice from './slices/components/fileManager/FileManagerSlice';
import AddFileModalSlice from './slices/components/addFileModal/AddFileModalSlice';
import FileUploadQueueSlice from './slices/components/fileUploadQueue/FileUploadQueueSlice';
import CompanyPermissionsSlice from './slices/components/companyPermissions/CompanyPermissionsSlice';
import UserProfileSlice from './slices/components/userProfile/UserProfileSlice';
import ChangePasswordModalSlice from './slices/components/changePasswordModal/ChangePasswordModalSlice';
import AgentManagementSlice from './slices/components/agentManagement/AgentManagementSlice';
import CreateAgentSlice from './slices/components/createAgent/CreateAgentSlice';

const rootReducer = combineReducers({
  AuthSlice,
  LayoutSlice,
  UserPreferencesSlice,
  CalendarEvents,
  UserSlice,
  MessengerSlice,
  ToastSlice,
  AgentSupervisionSlice,
  QuickDisplaySlice,
  OpenNaventSlice,
  PropertyConfiguratorSlice,
  SenderSlice,
  NotificationSlice,
  InstagramPostSlice,
  FavoritesSlice,
  TemplateConfigSlice,
  PortalSlice,
  InstagramPublicationsSlice,
  WebcontactSlice,
  PropertiesVisitSlice,
  RightbarSlice,
  HoggaxSlice,
  SharePropertiesMultipleSourcesSlice,
  WhatsAppSlice,
  WhatsAppTemplatesSlice,
  DashboardSlice,
  LeadsSlice,
  FilterBarSlice,
  CompanySettingsSlice,
  PdfConfigurationSlice,
  NetworksSlice,
  ListingRegistrationSlice,
  TasksSlice,
  DevelopmentsSlice,
  PortfolioManagerSlice,
  EventTypesSlice,
  ImporterSlice,
  ReferenceCodesSlice,
  BranchesAndTeamsSlice,
  FileManagerSlice,
  AddFileModalSlice,
  FileUploadQueueSlice,
  CompanyPermissionsSlice,
  UserProfileSlice,
  ChangePasswordModalSlice,
  AgentManagementSlice,
  CreateAgentSlice,
});

export default rootReducer;
